require('./../bootstrap');
require('jquery-datetimepicker');
require('jquery-validation');
require('@coreui/coreui');
require('./../component/custom-datetimepicker');
require('./../component/custom-validator');
require('./../component/table');
require('./../component/toast');
require('./../component/highlight-link');
require('./../common')
